import React from 'react';
import Select, { components } from "react-select";

const Menu = (props) => {
    return (
        <components.Menu {...props}>
            <div className="dropdowninnersection">
                <div className="dropdownlabelbtn">
                    <div className="dropheaderlabel">
                        {props.selectProps.menuHeader}
                    </div>
                    <button
                        className="dropheaderbtn"
                        onClick={props.selectProps.oncloseMenu}
                        type="button"
                    >
                        <img
                            src={require('../Public/images/dropcloseicon.png')}
                            alt="close"
                        />
                    </button>
                </div>
                <div>{props.children}</div>
            </div>
        </components.Menu>
    );
};

const AutosuggestComponent = ({
    // 🔹 defaults moved here (this fixes the warning)
    isClearable = false,
    closeButton = false,
    menuHeader = "",
    openMenu = true,
    isSearchable = false,
    id = "",
    menuPosition = "",
    maxMenuHeight = 300,

    // 🔹 remaining props
    selectedValue,
    options,
    name,
    isMulti,
    handleOnChange,
    handleOnInputChange,
    handleOnBlurChange,
    placeholder,
    isDisabled,
    handleFocus,
}) => {

    let selectRef = null;

    const oncloseMenu = () => {
        if (selectRef) {
            selectRef.select.blur();
        }
    };

    return (
        <div>
            {!closeButton ? (
                <Select
                    value={selectedValue}
                    isClearable={isClearable}
                    isSearchable={isSearchable}
                    options={options}
                    name={name}
                    isMulti={isMulti}
                    onChange={handleOnChange}
                    onInputChange={handleOnInputChange}
                    onBlur={handleOnBlurChange}
                    placeholder={placeholder}
                    isDisabled={isDisabled}
                    className="basic-select"
                    id={id}
                    menuPosition={menuPosition}
                    maxMenuHeight={maxMenuHeight}
                    classNamePrefix="dropdown_menu_box"
                    onFocus={handleFocus}
                />
            ) : (
                <Select
                    value={selectedValue}
                    isClearable={isClearable}
                    isSearchable={isSearchable}
                    options={options}
                    name={name}
                    isMulti={isMulti}
                    onChange={handleOnChange}
                    onInputChange={handleOnInputChange}
                    onBlur={handleOnBlurChange}
                    placeholder={placeholder}
                    isDisabled={isDisabled}
                    className="basic-select"
                    components={{ Menu }}
                    menuHeader={menuHeader}
                    oncloseMenu={oncloseMenu}
                    ref={(scope) => {
                        selectRef = scope;
                    }}
                    classNamePrefix="dropdown_menu_box"
                />
            )}
        </div>
    );
};

export default AutosuggestComponent;
